module.exports = __webpack_public_path__ + "static/media/lokale.1c842ad3.xlsx";